export default __webpack_public_path__ + "img/404-page-image.74f6ca4e478f3819234f5936f8241249.svg";